module.exports = __webpack_public_path__ + "static/media/4.4b0f4821.png";